import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinnerInContainer from '../../../UI/LoadingSpinnerInContainer/LoadingSpinnerInContainer';
import ListTitle from './ListTitle';
import CollaborativeListDataStore from '../../containers/CollaborativeListDataStore';

ListsTitleCouldBeOnSection.propTypes = {
	isLoading: PropTypes.bool,
	lists: PropTypes.array,
	community: PropTypes.object,
	skus: PropTypes.array,
};

function ListTitleWrapper({ list, children, skus = [] }) {
	if (skus.length < 2) {
		return children;
	} else {
		return (
			<CollaborativeListDataStore
				key={list.id}
				listId={list.id}
				communityId={list.communityId}>
				{children}
			</CollaborativeListDataStore>
		);
	}
}

function ListsTitleCouldBeOnSection({ isLoading, lists, community, skus }) {
	const availableListsContainerRef = React.useRef(null);

	const spinnerHeight = availableListsContainerRef.current?.clientHeight;

	return (
		<div
			className="community-lists-available-container"
			ref={availableListsContainerRef}>
			{isLoading ? (
				<LoadingSpinnerInContainer height={spinnerHeight} />
			) : (
				lists.map(list => (
					<ListTitleWrapper key={list.id} list={list} skus={skus}>
						<ListTitle
							skus={skus}
							list={list}
							community={community}
						/>
					</ListTitleWrapper>
				))
			)}
		</div>
	);
}

export default ListsTitleCouldBeOnSection;
